import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { Box, Toolbar } from "@mui/material";
import AdminNavBar from "../components/lab_admin/AdminNavBar";
import Sidebar from "../components/lab_admin/Sidebar";
import SEO from '../components/SEO';
const AdminLayout = () => {
  const [collapsed, setCollapsed] = useState(true);
  const toggleDrawer = () => {
    setCollapsed(prev => !prev);
  };
  return (
    <>
      <SEO />
      <Box display="flex" minHeight="100vh">
        <AdminNavBar toggleDrawer={toggleDrawer} /> 
        <Sidebar collapsed={collapsed} />
        <Box 
          component="main" 
          sx={{
            flexGrow: 1,
            transition: 'margin-left 0.3s ease',
            p: 3,
          }}>
          <Toolbar />
          <Outlet />
        </Box>
      </Box>
    </>
  );
};

export default AdminLayout;